export enum IBQuestionType {
    TEXT = 'TEXT', NUMBER = 'NUMBER', DATE = 'DATE'
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/models/ib-question-type.ts